import {TFunction} from "react-i18next";
import {ColumnsType} from "antd/lib/table/interface";
import {StatementFile} from "../../../models/accounting/statements";
import dayjs from "dayjs";

export const columnsFactory = (t: TFunction<"translation">, generateUri: (uri: string) => string): ColumnsType<StatementFile> => {
    return [
        {
            title: t("YEAR"),
            dataIndex: "year",
            key: "year"
        },
        {
            title: t("MONTH"),
            dataIndex: "month",
            key: "month",
            render: month =>
                <>{dayjs().month(month - 1).format('MMM')} ({month})</>
        },
        {
            title: t("FILENAME"),
            dataIndex: "filename",
            key: "filename",
            render: (filename: string, row: StatementFile) =>
                <a href={generateUri("/api/v3/accounting/statements-files/" + row.id + "/" + filename)}>{filename}</a>
        }
    ];
}